export default class SpritePool {
  constructor(Type, length, scene) {
    this.pool = [];
    let i = length;
    while (--i > -1) {
      this.pool[i] = new Type(scene);
      this.pool[i].setVisible(false);
    }
  }

  getSprite() {
    if (this.pool.length > 0) {
      const item = this.pool.pop();
      item.setVisible(true).setAlpha(1)
        .setScale(1)
        .setAngle(0);

      return item;
    }
    else {
      return null;//   throw new Error("You ran out of sprites!");
    }
  };

  returnSprite(sprite) {
    sprite.setVisible(false).setAlpha(1)
      .setScale(1)
      .setAngle(0);
    this.pool.push(sprite);
  };
}